module.exports = __webpack_public_path__ + "assets/img/cart-add.6e7c29ca.png";